<template lang="pug">
  b-modal#changePwdUser(
  ref="changePwdUser"
  :title="$t('ui.combine.edit_password')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.name')").mb-3
        div.form-control.form-control-sm.disabled {{ userName }}
      b-form-group(:label="$t('ui.password')").mb-0
        DebounceInput(
            size="sm"
            ref="dataEdit_userPwd"
            required
            type="password"
            :dirty="$v.dataEdit_userPwd.$dirty"
            :error="$v.dataEdit_userPwd.$error"
            v-model.trim.lazy="$v.dataEdit_userPwd.$model"
            :disabled="loading"
            autocomplete="section-red new-password"
            :maxLength="$v.dataEdit_userPwd.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataEdit_userPwd" :name="$t('ui.password')")
      b-form-group(:label="$t('ui.combine.confirm_password')")
        DebounceInput(
            size="sm"
            required
            type="password"
            :dirty="$v.dataEdit_userPwdConfirm.$dirty"
            :error="$v.dataEdit_userPwdConfirm.$error"
            v-model.trim.lazy="$v.dataEdit_userPwdConfirm.$model"
            :disabled="loading"
            autocomplete="section-red new-password"
            :maxLength="$v.dataEdit_userPwd.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataEdit_userPwdConfirm" :name="$t('ui.combine.confirm_password')" :name2="$t('ui.password')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    userId: "",
    userName: ""
  },
  data() {
    return {
      dataEdit_userPwd: "",
      dataEdit_userPwdConfirm: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataEdit_userPwd: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    dataEdit_userPwdConfirm: {
      required,
      sameAs: sameAs("dataEdit_userPwd")
    }
  },
  computed: {
    getUserId: function() {
      return this.userId;
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.resetPwdUserUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.user,
          user_id: this.userId,
          password: this.dataEdit_userPwd
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.changePwdUser.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  // this.$emit("failed", "edit_password", this.feedback.status);
                  // this.$refs.changePwdUser.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.dataEdit_userPwd = "";
      this.dataEdit_userPwdConfirm = "";

      this.$nextTick(() => {
        this.$v.$reset();
        this.$refs.dataEdit_userPwd.$el.focus();
      });
    }
  }
};
</script>
